import React, { useState, useEffect } from "react";
import { api_v2 } from "../../NewIndex.api";
import widgetDefaultImage1 from "./assets/widget1.png";
import widgetDefaultImage2 from "./assets/widget2.png";
import widgetDefaultImage3 from "./assets/widget3.png";

const widgetTypeDefaultImageMap = {
  "Widget Type 1": widgetDefaultImage1,
  "Widget Type 2": widgetDefaultImage2,
  "Widget Type 3": widgetDefaultImage3,
};
function getDefaultImage(type) {
  return widgetTypeDefaultImageMap[type];
}

const WidgetPreviewBox = ({ widget }) => {
  const [imgUrl, setImgUrl] = useState("");
  useEffect(() => {
    var id =
      widget && widget.widgetRequirement && widget.widgetRequirement.image;
    if (id) {
      api_v2.fetchAndSetImage(
        id,
        function (blob) {
          var url = window.URL.createObjectURL(blob);
          setImgUrl(url);
        },
        function (e) {
          setImgUrl("");
          console.warn(e.message);
        }
      );
    } else {
      setImgUrl("");
    }
  }, [
    widget && widget.widgetRequirement && widget.widgetRequirement.image,
    widget && widget.widgetType,
  ]);

  if (!widget || !widget.widgetType) {
    return <span style={{ opacity: 0.7 }}>Not configured</span>;
  }

  const htmlContent =
    widget && widget.widgetRequirement && widget.widgetRequirement.htmlContent
      ? widget.widgetRequirement.htmlContent
      : "";
  const imageTitle =
    widget && widget.widgetRequirement && widget.widgetRequirement.imageTitle
      ? widget.widgetRequirement.imageTitle
      : "";
  const imageSrc = imgUrl || getDefaultImage(widget.widgetType);
  const type = widget.widgetType;

  const outerStyle = {
    width: "100%",
    height: "100%",
    background: "#fff",
    boxShadow: "0 1px 8px #bcc",
    borderRadius: 8,
    boxSizing: "border-box",
    overflow: "auto", // BOTH vertical and horizontal scrollbars if needed
    display: "flex",
    flexDirection:
      type === "Widget Type 2"
        ? "row"
        : type === "Widget Type 3"
        ? "row"
        : "column",
    alignItems: "stretch",
    minWidth: 0,
  };
  const contentStyle = {
    fontSize: 18,
    lineHeight: 1.6,
    minWidth: 0,
    minHeight: 0,
    padding: 16,
    boxSizing: "border-box",
    // overflowWrap: "break-word",
    wordBreak: "normal", 
    whiteSpace: "normal", 
    width: "100%",
    height: "100%",
    maxWidth: "100%",
    display: "block",
  };

  if (type === "Widget Type 1") {
    return (
      <div style={outerStyle}>
        <div
          style={{
            position: "relative",
            width: "100%",
            height: 200,
            minHeight: 80,
            flex: "none",
          }}
        >
          <img
            src={imageSrc}
            alt={imageTitle}
            style={{
              width: "100%",
              height: 200,
              // objectFit: "cover",
              display: "block",
            }}
          />
          {imageTitle && (
            <div
              style={{
                position: "absolute",
                bottom: 0,
                // left: 0,
                width: "100%",
                background: "rgba(30,35,45,0.65)",
                color: "#fff",
                fontWeight: 600,
                fontSize: 20,
                padding: "8px 0",
                textAlign: "center",
                height:"inherit",
                display:"flex",
                justifyContent:"center",
                alignItems:"center"
              }}
            >
              {imageTitle}
            </div>
          )}
        </div>
        <div
          style={{ ...contentStyle }}
          dangerouslySetInnerHTML={{ __html: htmlContent }}
        />
      </div>
    );
  }
  if (type === "Widget Type 2") {
    return (
      <div style={outerStyle}>
        <div
          style={{ ...contentStyle, flex: 1, overflow: "auto" }}
          dangerouslySetInnerHTML={{ __html: htmlContent }}
        />
        <div
          style={{
            width: 170,
            minWidth: 0,
            height: "100%",
            background: "#f7f8fa",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img
            src={imageSrc}
            alt={imageTitle}
            style={{
              maxWidth: 150,
              maxHeight: 210,
              objectFit: "cover",
              borderRadius: 8,
            }}
          />
        </div>
      </div>
    );
  }
  if (type === "Widget Type 3") {
    return (
      <div style={outerStyle}>
        <div
          style={{
            width: 170,
            minWidth: 0,
            height: "100%",
            background: "#f7f8fa",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img
            src={imageSrc}
            alt={imageTitle}
            style={{
              maxWidth: 150,
              maxHeight: 210,
              objectFit: "cover",
              borderRadius: 8,
            }}
          />
        </div>
        <div
          style={{ ...contentStyle, flex: 1, overflow: "auto" }}
          dangerouslySetInnerHTML={{ __html: htmlContent }}
        />
      </div>
    );
  }
  if (type === "Widget Type 4") {
    return (
      <div style={outerStyle}>
        <div
          style={{
            ...contentStyle,
            height: "100%",
            overflow: "auto",
            fontSize: 20,
            color: "#111",
          }}
          dangerouslySetInnerHTML={{ __html: htmlContent }}
        />
      </div>
    );
  }
  return (
    <div style={outerStyle}>
      <div style={{ padding: 24, color: "#888" }}>
        No preview available for this widget type.
      </div>
    </div>
  );
};
export default WidgetPreviewBox;



// WEBPACK FOOTER //
// ./src/mi-app/adminPanel/Content Management/WidgetPreviewBox.js